export const multipleDevicesUrl = 'multiple-devices/';
